<template>
    <div>
        <loading :active.sync="loadingApp" :can-cancel="false" :is-full-page="true" :color="'#0B8BCC'" :loader="'dots'" :opacity="0.7" :lock-scroll="true"></loading>
        <Toast :show.sync="toast.show" :message="toast.message" :tipe="toast.tipe" @close="toast.show = false" :position="toast.position" :icon="toast.icon"></Toast>
        <!-- App Header -->
        <div class="appHeader bg-primary text-light">
            <div class="left">
                <router-link :to="{name:'transaction.index'}" class="headerButton">
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </router-link>
            </div>
            <div class="pageTitle">Detail Transaksi</div>
        </div>
        <!-- * App Header -->
        <div id="appCapsule" class="pb-2" v-if="loadingApp == false">
            <div class="section detail-transaction-section pt-4" style="--height:150px;">
                <div class="detail-card">
                    <div class="listed-detail mt-1">
                        <div class="icon-wrapper" v-if="transaction.status == 'PENDING' || transaction.status == 'ONPROCESS'">
                            <div class="iconbox bg-warning">
                                <ion-icon name="refresh-outline"></ion-icon>
                            </div>
                        </div>
                        <div class="icon-wrapper" v-if="transaction.status == 'SUCCESS'">
                            <div class="iconbox bg-success">
                                <ion-icon name="checkmark-outline"></ion-icon>
                            </div>
                        </div>
                        <div class="icon-wrapper" v-if="transaction.status == 'FAILED'">
                            <div class="iconbox bg-danger">
                                <ion-icon name="close-outline"></ion-icon>
                            </div>
                        </div>
                        <div class="icon-wrapper" v-if="transaction.status == 'HOLDON'">
                            <div class="iconbox bg-primary">
                                <ion-icon name="pause-outline"></ion-icon>
                            </div>
                        </div>
                        <h2 class="text-center mt-2 mb-1">{{ transaction.product_name }}</h2>
                        <h3 class="text-center">{{ transaction.destination }}</h3>
                    </div>
                    <div class="listed-detail mt-1">
                        <dd class="mb-0">ID Transkasi <b>#{{ transaction.id }}</b></dd>
                        <dd class="mb-0">Status Transkasi<br>
                            <div class="chip chip-warning" v-if="transaction.status == 'PENDING' || transaction.status == 'ONPROCESS'">
                                <span class="chip-label">Pending</span>
                            </div>
                            <div class="chip chip-success" v-if="transaction.status == 'SUCCESS'">
                                <span class="chip-label">Berhasil</span>
                            </div>
                            <div class="chip chip-danger" v-if="transaction.status == 'FAILED'">
                                <span class="chip-label">Gagal</span>
                            </div>
                            <div class="chip chip-primary" v-if="transaction.status == 'HOLDON'">
                                <span class="chip-label">Holdon</span>
                            </div>
                        </dd>
                        <dd class="mb-0"><small>Tanggal {{ transaction.created_at }}</small></dd>
                    </div>
                    <div class="listed-detail mt-1">
                        <blockquote class="blockquote p-1 mt-2 mb-1">
                            <p class="mb-0"><ion-icon name="alert-circle"></ion-icon> Detail Transaksi</p>
                        </blockquote>
                        <table>
                            <tr>
                                <td width="130px">Produk</td>
                                <td width="20px">:</td>
                                <td><b>{{ transaction.product_name }}</b></td>
                            </tr>
                            <tr v-if="transaction.product_detail != null">
                                <td width="130px">Detail Produk</td>
                                <td width="20px">:</td>
                                <td>{{ transaction.product_detail }}</td>
                            </tr>
                            <tr>
                                <td width="130px">SN / Token</td>
                                <td width="20px">:</td>
                                <td style="word-wrap: break-word">{{ transaction.serial_number }}</td>
                            </tr>
                            <!-- <tr>
                                <td width="130px">Waktu Proses</td>
                                <td width="20px">:</td>
                                <td>{{ transaction.process_time != null ? transaction.process_time+' detik':'-' }}</td>
                            </tr> -->
                        </table>
                    </div>
                    <div class="listed-detail mt-1" style="border-bottom:0px;">
                        <blockquote class="blockquote p-1 mt-2 mb-1">
                            <p class="mb-0"><ion-icon name="alert-circle"></ion-icon> Detail Pembayaran</p>
                        </blockquote>
                        <table>
                            <tr>
                                <td width="130px">Harga Modal</td>
                                <td width="20px">:</td>
                                <td>Rp {{ transaction.price | rupiah }}</td>
                            </tr>
                            <tr>
                                <td width="130px">Harga Jual</td>
                                <td width="20px">:</td>
                                <td style="display: inline-flex;">
                                    Rp {{ transaction.price_selling | rupiah }} 
                                    <a href="Javascript:;" v-if="transaction.status == 'SUCCESS'" class="ml-1" style="font-size:20px;" @click="actionSheetPriceSelling('show')">
                                        <ion-icon name="create-outline"></ion-icon>
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td width="130px">Cashback</td>
                                <td width="20px">:</td>
                                <td>Rp {{ transaction.cashback | rupiah }}</td>
                            </tr>
                            <tr>
                                <td width="130px">Profit Penjualan</td>
                                <td width="20px">:</td>
                                <td class="text-success" v-if="transaction.status == 'SUCCESS'">Rp {{ transaction.price_selling - transaction.price | rupiah }}</td>
                                <td class="text-success" v-else>Rp 0</td>
                            </tr>
                        </table>
                    </div>
                    <div class="listed-detail mt-1" style="border-bottom:0px;" v-if="transaction.status == 'SUCCESS'">
                        <button class="btn btn-primary btn-block" @click="print()"><ion-icon name="print"></ion-icon> Print Struk</button>
                        <a :href="'https://api.whatsapp.com/send?text=Pembelian '+transaction.product_name+' ke '+transaction.destination+' telah berhasil dengan SN : '+transaction.serial_number+' pada '+transaction.created_at+' dengan harga Rp '+$options.filters.inputRupiah(transaction.price_selling)+'. Terima Kasih'" target="_blank" class="btn btn-success btn-block">
                            <ion-icon name="logo-whatsapp"></ion-icon> Kirim Laporan Transkasi
                        </a>
                        <a :href="'https://play.google.com/store/apps/details?id='+VUE_ENV.VUE_APP_PACKAGENAME_APK" target="_blank" class="btn btn-dark btn-block">
                            <ion-icon name="logo-google-playstore"></ion-icon> Beri Rating
                        </a>
                        <!-- <button class="btn btn-primary btn-block" @click="coming()"><ion-icon name="cloud-download"></ion-icon> Download Struk</button> -->
                    </div>
                </div>
            </div>
        </div>

        <action-sheet ref="edit_harga_jual" :title="'Ubah Harga Jual'" :inset="true">
            <div class="form-group basic">
                <label class="label">Set Harga Jual</label>
                <div class="input-group input-group-sm">
                    <div class="input-group-prepend">
                        <span class="input-group-text">Rp</span>
                    </div>
                    <input type="tel" class="form-control form-control-sm" v-model="price_selling" @input="inputPriceSelling">
                </div>
                <small class="text-danger" v-if="errors.price_selling"><i>{{ errors.price_selling[0] }}</i></small>
            </div>
            <div class="form-group basic">
                <div class="row">
                    <div class="col-6">
                        <button class="btn btn-secondary btn-block" @click="actionSheetPriceSelling('hide')"> Batal</button>
                    </div>
                    <div class="col-6">
                        <ButtonLoader :loading="loadingButton" :styled="'btn btn-primary btn-block'" @click.native="updatePriceSelling()">Simpan</ButtonLoader>
                    </div>
                </div>
            </div>
        </action-sheet>
    </div>
</template>
<script>
import $axios from './../../../api.js'
import { mapActions, mapState } from 'vuex'
export default {
    data() {
        return {
            transaction: {},
            price_selling: '0',
            loadingApp: true,
            loadingButton: false,
        }
    },
    created() {
        this.getDetail(this.$route.params.id)
    },
    computed: {
        ...mapState(['errors','toast','VUE_ENV']),
    },
    methods: {
        ...mapActions(['coming']),
        actionSheetPriceSelling(value){
            if(value == 'show'){
                this.price_selling =  this.$options.filters.inputRupiah(this.transaction.price_selling)
            }
            let element = this.$refs.edit_harga_jual.$el
            window.$(element).modal(value)
        },
        getDetail(id){
            $axios.get('/transaction/prabayar/'+id)
            .then(response => {
                this.transaction = response.data.data
                this.loadingApp = false
            }).catch(() => {
                this.loadingApp = false
            })
        },
        print(){
            if (typeof window.AndroidNative !== 'undefined') {
                window.AndroidNative.print();
            }else{
                this.$store.commit('SET_TOAST', {show:true,message:'Fitur ini hanya bisa digunakan diperangkat Android, silahkan download aplikasi di Playstore',tipe:'default',icon:'warning'})
            }
        },
        inputPriceSelling(){
            this.price_selling = this.$options.filters.inputRupiah(this.price_selling)
        },
        updatePriceSelling(){
            this.loadingButton = true
            $axios.post('/transaction/prabayar/'+this.$route.params.id+'/update-price-selling', {
                price_selling: this.price_selling
            })
            .then(() => {
                this.loadingButton = false
                this.actionSheetPriceSelling('hide')
                this.getDetail(this.$route.params.id)
                this.$store.commit('SET_TOAST', {show:true,message:'Berhasil',tipe:'default',icon:'success'})
            }).catch((error) => {
                this.actionSheetPriceSelling('hide')
                this.$store.commit('SET_TOAST', {show:true,message:error.response.data.message,tipe:'default',icon:'danger'})
                this.loadingButton = false
                
            })
        }
    },
    destroyed() {
        this.$store.commit('CLEAR_ERRORS')
        this.$store.commit('RESET_TOAST')
    },
    filters:{
        inputRupiah: function(value){
            value = value.toString()
            var number_string = value.replace(/[^,\d]/g, '').toString(),
            split   		= number_string.split(','),
            sisa     		= split[0].length % 3,
            rupiah     		= split[0].substr(0, sisa),
            ribuan     		= split[0].substr(sisa).match(/\d{3}/gi);

            if(ribuan){
                var separator = sisa ? '.' : '';
                rupiah += separator + ribuan.join('.');
            }

            rupiah = split[1] != undefined ? rupiah + ',' + split[1] : rupiah;
            return rupiah
        },
    }
}
</script>